import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

const CORE_MODULES = [CommonModule, RouterModule, FormsModule, ReactiveFormsModule];

@NgModule({
  imports: [...CORE_MODULES],
  exports: [...CORE_MODULES],
  declarations: [],
  providers: [],
})
export class CoreModule {}
